import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppConfigService} from '../core/config/app-config.service';
import {Team} from './models/team.model';
import {AbsenceService} from '../shared/globals/absence-service.service';

@Injectable({
    providedIn: 'root'
})
export class AdminService {

    private readonly baseUrl;

    //Defines order to sort data by
    constructor(private readonly httpClient: HttpClient,
                private readonly configService: AppConfigService,
                private readonly absenceService: AbsenceService) {
        this.baseUrl = configService.getConfig().baseUrl;
    }

    /**
     * Makes back-end request to fetch the Team data
     */
    public fetchAllTeams(): Observable<Team[]> {
        return this.absenceService.getRequest(this.baseUrl, '/team');
    }
}
